import React from 'react';
import Portfolio from '../containers/Portfolio';
import './style.css';
export default function App() {
  return (
    <Portfolio />
  );
}
